import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import CssBaseline from '@material-ui/core/CssBaseline';
import Modal from './components/Modal/Provider';
import Loading from './components/Loading';

import Hydrated from './Hydrated';
import { loadUser } from './store/actions/user';

const history = createBrowserHistory();

const { location } = history;

if (location.hash.includes('#!/')) history.replace(location.hash.replace('#!/', ''));

history.listen((_location) => {
  if (_location.hash.includes('#!/')) history.replace(_location.hash.replace('#!/', ''));
});

const App = () => {
  const loading = useSelector(state => state.user.loading);
  // const error = useSelector(state => state.user.error)
  // const data = useSelector(state => state.user.data)

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  if (loading) return <Loading />;

  return (
    <Router history={history}>
      <CssBaseline />
      <Hydrated />
      <Modal />
    </Router>
  );
};

export default App;
